/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export enum AccountTypes {
  C = "Checking",
  S = "Savings"
}
